import { vec4 } from 'gl-matrix';

import {
  type Vector4 as Vector4Interface,
  type Vector4Source,
} from '@canvas/vector-types';

/**
 * @deprecated
 */
export class Vector4 implements Vector4Interface {
  public readonly type = 'Vector4';

  /**
   * @deprecated use vec4 from gl-matrix instead when possible
   */
  constructor(public x: number, public y: number, public z: number, public w: number) {}

  public static from({ x, y, z, w }: Vector4Source) {
    return new Vector4(x, y, z, w);
  }

  static fromVector3(
    { x, y, z }: { x: number; y: number; z: number },
    w: number
  ): Vector4 {
    return new Vector4(x, y, z, w);
  }

  static fromHexColor(color: string, opacity = 1) {
    let r: number;
    let g: number;
    let b: number;
    let a = 255;

    if (color.length === 4) {
      r = parseInt(color[1] + color[1], 16);
      g = parseInt(color[2] + color[2], 16);
      b = parseInt(color[3] + color[3], 16);
      a = 255;
    } else {
      r = parseInt(color.slice(1, 3), 16);
      g = parseInt(color.slice(3, 5), 16);
      b = parseInt(color.slice(5, 7), 16);
    }

    if (color.length >= 9) {
      a = parseInt(color.slice(7, 9), 16);
    }

    return new Vector4(r, g, b, Math.round(a * opacity));
  }

  public toArray(): vec4 {
    return vec4.fromValues(this.x, this.y, this.z, this.w);
  }
}

export const emptyVector4 = new Vector4(0, 0, 0, 0);

export const isVector4 = (item: Vector4): item is Vector4 => {
  return !!item && item.type === 'Vector4';
};
